
let host = '/api/'
export default {
  getUserInfo:`${host}user/info/v2`, //获取用户信息
  modifyName: `${host}user/modify/nickname`,
  //修改签名
  modifySign:`${host}user/modify/memo`,

  sendcodes:`${host}mobile/sendvercode/changemobile`, //验证码
  modifyPhone:`${host}user/modify/mobile/old`, //修改手机号老
  modifyPhoneN:`${host}user/modify/mobile/new`,    //修改手机号新

  mainUrl:`${process.env.DOMAIN_RUL}/wap/`,
  upload:`/api/file/upload`,    //获取验证码

  trackPv:`/api/web/track/pv`,    //获取验证码

  saveChannel:`${host}channel/save`,

  getCurrentTimeMillis:`${host}time/timemillis`,
  getCurrentTimeMillisDiff1:`${host}time/timemillis/diff/1`,

  
// curl -X GET "http://39.101.205.48:8500/api/login/wx/jsapi/signature?url=abc" -H
// "Request-Origion:SwaggerBootstrapUi" -H "accept:*/*" -H "x-auth-token:e31632be-55b4-41ea-ae6f-9eecf140ccf5"
  getSignature:`/api/login/wx/jsapi/signature`,    //获取验证码


  //注销用户
  logOff:`${host}user/logoff`,

//实名认证
  verify:`${host}user/identity/apply`,
  //订阅
  subscribe:`${host}product/subscribe`,
  unsubscribe:`${host}product/unsubscribe`,

  getcode: '/api/mobile/sendvercode',
  login: '/api/login/mobile/code',
  banner: '/api/banner/list', //轮播图
  product: '/api/product/list', //数字藏品
  sellList: '/api/product/list/sell', //发售日历
  bestList: '/api/product/best/list', //内容精选列表
  productDetail: '/api/product/', //数字藏品详细
  poster: '/api/product/poster/', //生成海报

  //详情
  //api/product/{productId}
  productDetail:`${host}product/`,
  productDetailBest:`${host}product/best/`,

  // otherProduct:`${host}product/near/`,
  otherProduct:'/api/product/best/near/list/v2',
  myColletlist:'/api/user/product/list',//我的藏品列表
  myColletDetail:'/api/user/product/',  //我的藏品详情
  myShow:'/api/user/product/show/',//我的炫耀
  myGive:'/api/user/product/give/',//我的赠送

  //订单列表
  orderlist:`${host}order/list`,
  orderdetails:`${host}order/`,
  tobuy:`${host}order/buy`,//去购买
  tobuyV2:`${host}order/buy/v2`,//去购买
  commitOrder:`${host}order/commit`,//提交订单
  commitPay:`/api/order/pay/commit`,//购买
  commitPayV2:`/api/order/pay/commit/v2`,//购买
  orderPay:`/api/order/`,//购买
  orderCancel:`${host}order/cancel`,//取消订单
  downLoad:`${host}file/download`,
  
  //paycallback:`${host}order/notify`,//支付回调

  wxoauth:`${host}user/wx/oauth/status`,
  wxosave:`${host}login/wx/mp`,
  wxmpurl:`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.WP_APPID}&redirect_uri=${process.env.DOMAIN_RUL}%2Fapi%2Flogin%2Fwx%2Fmp&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
};


// WEBPACK FOOTER //
// ./src/js/api.js